import { cva } from "class-variance-authority";

export const registrationFeedbackCommentRootStyles = cva([
  "flex w-full flex-col items-stretch gap-6 text-left",
  "lg:items-center lg:gap-8 lg:text-center",
]);

export const registrationFeedbackCommentHeaderStyles = cva([
  "flex w-full flex-col items-start gap-6 text-left",
  "lg:items-center lg:text-center",
]);

export const registrationFeedbackCommentIconStyles = cva([
  "size-16 aspect-square shrink-0",
  "lg:size-20",
]);

export const registrationFeedbackCommentTitleStyles = cva([
  "hidden lg:block",
  "m-0 max-w-[640px] font-[Canela_Text,serif] text-[40px] font-black leading-[1.2] tracking-[0.1px] text-[#1B1C1D]",
]);

export const registrationFeedbackCommentCopyStyles = cva([
  "flex w-full flex-col gap-0 lg:hidden",
]);

export const registrationFeedbackCommentIntroStyles = cva([
  "m-0 max-w-[640px] font-[Poppins,sans-serif] text-[22px] font-medium leading-7 text-[#003049]",
]);

export const registrationFeedbackCommentPromptStyles = cva([
  "m-0 max-w-[640px] font-[Poppins,sans-serif] text-[22px] font-normal leading-7 text-[#003049]",
]);

export const registrationFeedbackCommentPromptBeforeStyles = cva(["font-normal"]);

export const registrationFeedbackCommentPromptAfterStyles = cva(["font-normal"]);

export const registrationFeedbackCommentRatingStyles = cva(["font-medium"]);

export const registrationFeedbackCommentDesktopCopyStyles = cva([
  "hidden lg:block",
  "m-0 max-w-[640px] font-[Poppins,sans-serif] text-[22px] font-normal leading-7 text-[#1B1C1D]",
]);

export const registrationFeedbackCommentFieldSectionStyles = cva([
  "flex flex-1 flex-col items-start gap-4 self-stretch w-full",
  "lg:gap-1",
]);

export const registrationFeedbackCommentBoxStyles = cva([
  "w-full self-stretch",
  "lg:flex lg:flex-col lg:h-[240px] lg:p-6 lg:gap-5 lg:items-stretch",
  "lg:rounded-[16px] lg:border lg:border-outline/16 lg:bg-white",
]);

export const registrationFeedbackCommentFieldWrapperStyles = cva([
  "w-full self-stretch",
  "max-lg:[&>div:first-child]:flex max-lg:[&>div:first-child]:min-h-[240px] max-lg:[&>div:first-child]:flex-col max-lg:[&>div:first-child]:items-stretch",
  "max-lg:[&>div:first-child]:rounded-[16px] max-lg:[&>div:first-child]:border max-lg:[&>div:first-child]:border-outline/16 max-lg:[&>div:first-child]:bg-white",
  "max-lg:[&>div:first-child]:shadow-none max-lg:[&>div:first-child]:ring-0",
  "max-lg:[&>div:first-child]:focus-within:border max-lg:[&>div:first-child]:focus-within:border-outline/16",
  "lg:flex lg:flex-1 lg:min-h-0 lg:flex-col",
  "lg:[&>div:first-child]:min-h-0 lg:[&>div:first-child]:flex-1 lg:[&>div:first-child]:flex lg:[&>div:first-child]:flex-col",
  "lg:[&>div:first-child]:border-0 lg:[&>div:first-child]:rounded-none lg:[&>div:first-child]:bg-transparent",
  "lg:[&>div:first-child]:shadow-none lg:[&>div:first-child]:ring-0",
  "lg:[&>div:first-child]:focus-within:border-0 lg:[&>div:first-child]:focus-within:ring-0",
  "[&_textarea]:min-h-0 [&_textarea]:flex-1 [&_textarea]:font-[Poppins,sans-serif] [&_textarea]:font-normal [&_textarea]:tracking-[0.4px] [&_textarea]:text-[#1B1C1D] [&_textarea]:!px-4 [&_textarea]:!pt-4 [&_textarea]:!pb-4 [&_textarea]:resize-none",
  "lg:[&_textarea]:flex-1 lg:[&_textarea]:min-h-0 lg:[&_textarea]:w-full",
  "lg:[&_textarea]:!p-0 lg:[&_textarea]:!m-0 lg:[&_textarea]:bg-transparent lg:[&_textarea]:border-0 lg:[&_textarea]:outline-none lg:[&_textarea]:resize-none",
  "lg:[&_textarea]:!pl-0 lg:[&_textarea]:!pr-0 lg:[&_textarea]:!py-0",
  "[&_textarea::placeholder]:font-[Poppins,sans-serif]",
  "[&_textarea::placeholder]:font-normal",
  "[&_textarea::placeholder]:tracking-[0.4px]",
  "[&_textarea::placeholder]:text-[#74777C]",
  "[&>div:last-child]:w-full [&>div:last-child]:justify-end [&>div:last-child]:px-0",
  "lg:[&>div:last-child]:hidden",
  "[&>div:last-child>span:last-child]:font-[Poppins,sans-serif]",
  "[&>div:last-child>span:last-child]:text-xs",
  "[&>div:last-child>span:last-child]:font-normal",
  "[&>div:last-child>span:last-child]:leading-4",
  "[&>div:last-child>span:last-child]:tracking-[0.4px]",
  "[&>div:last-child>span:last-child]:text-[#1B1C1D]",
]);

export const registrationFeedbackCommentCounterStyles = cva([
  "hidden lg:block w-full text-right m-0",
  "font-[Poppins,sans-serif] text-xs font-normal leading-4 tracking-[0.4px] text-[#1B1C1D]",
]);

export const registrationFeedbackCommentActionsStyles = cva([
  "flex w-full max-w-none flex-col items-center gap-4",
  "lg:max-w-[476px]",
]);
